module.exports = __webpack_public_path__ + "images/ed257c60014e2a9565bbad7e4321952004206b1e0e51d84cbf0b309280261f94.svg";